import React, { useState } from "react";
import { Grid, useMediaQuery } from "@mui/material";
import { Button, FunctionField, Labeled, SimpleShowLayout } from "react-admin";
import { settings } from "app";
import RoomField from "server/components/Fields/RoomField";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import EditIcon from "@mui/icons-material/Edit";
import StateExamSlotEditForm from "./StateExamSlotEditForm";
import { SectionTitle } from "features/SectionTitle";

const StateExamSlots = ({ record }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const [isSlotEditing, setIsSlotEditing] = useState(false);

  const handleSlotEditClick = () => {
    setIsSlotEditing(true);
  };

  return (
    <>
      <SectionTitle
        title="Време и място на провеждане"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <SimpleShowLayout>
        <Grid
          container
          spacing={2}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          {isSlotEditing ? (
            <StateExamSlotEditForm
              record={record}
              setIsSlotEditing={setIsSlotEditing}
            />
          ) : (
            <>
              <Grid
                item
                xs={12}
                md={6}
              >
                <Labeled label="Зала">
                  <RoomField
                    label="Зала"
                    render={rec => `${rec?.roomName} - ${rec?.buildingName} (${rec?.capacityExam})`}
                  />
                </Labeled>
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
              >
                <Labeled label="Дата и час на изпит">
                  <FunctionField render={rec => new Date(rec.examTimestamp).toLocaleString("bg-BG")} />
                </Labeled>
              </Grid>
              <Grid
                item
                xs={12}
                md={4}
              >
                <SecuredComponent permission={permissions.canManageStateExamSlot}>
                  <Button
                    variant="contained"
                    startIcon={<EditIcon />}
                    label="Редактирай"
                    onClick={handleSlotEditClick}
                  />
                </SecuredComponent>
              </Grid>
            </>
          )}
        </Grid>
      </SimpleShowLayout>
    </>
  );
};

export default StateExamSlots;
